import { PlanScheme } from './FlowSelectPlanWidgetV2.types'

export const PROCEED_EVENT_NAME = 'proceed'
export const LOAD_EVENT_NAME = 'load'

export const EUROPE_SCHEME_CODE = '5004'
export const EUROPE_VARIANT = 'europe'
export const WORLDWIDE_VARIANT = 'worldwide'
export const SINGLE_VARIANT = 'single'

export const MAX_DEPARTURE_DAY_WITHOUT_TODAY = 89
export const MAX_DEPARTURE_DAY_WITHOUT_TODAY_OUTBOUND = 179
export const MAX_DEPARTURE_DAY_WITHOUT_TODAY_USA = 59
export const MULTI_TRIP_RETURN_DAY = 180

export const SCHEME_CODE_MAP: Record<PlanScheme, string[]> = {
  [PlanScheme.Worldwide]: ['5007', '5055', '5003'],
  [PlanScheme.WorldwideExcludingUSAAndCanada]: ['5006', '5054', '5002'],
  [PlanScheme.FlyEurope]: ['5008', '5056', '5004'],
  [PlanScheme.Regional]: ['5005', '5053', '5001'],
}

export const VALID_COMBINATIONS: PlanScheme[][] = [
  [PlanScheme.Worldwide],
  [PlanScheme.Worldwide, PlanScheme.WorldwideExcludingUSAAndCanada],
  [PlanScheme.WorldwideExcludingUSAAndCanada],
  [PlanScheme.WorldwideExcludingUSAAndCanada, PlanScheme.Regional],
  [PlanScheme.WorldwideExcludingUSAAndCanada, PlanScheme.FlyEurope],
]

export const COMBINATION_COVERAGE_TEXT: [PlanScheme[], string[]][] = [
  [
    [PlanScheme.Worldwide],
    ['outbound.select_plan.coverage.worldwide'], // prettier-ignore
  ],
  [
    [PlanScheme.Worldwide, PlanScheme.WorldwideExcludingUSAAndCanada],
    ['outbound.select_plan.coverage.worldwide', 'outbound.select_plan.coverage.worldwide_excl'], // prettier-ignore
  ],
  [
    [PlanScheme.WorldwideExcludingUSAAndCanada],
    ['outbound.select_plan.coverage.worldwide', 'outbound.select_plan.coverage.worldwide_excl'], // prettier-ignore
  ],
  [
    [PlanScheme.WorldwideExcludingUSAAndCanada, PlanScheme.Regional],
    ['outbound.select_plan.coverage.regional'],
  ],
  [
    [PlanScheme.WorldwideExcludingUSAAndCanada, PlanScheme.FlyEurope],
    ['outbound.select_plan.coverage.fly_europe'],
  ],
]

export const COMBINATION_DESCR_TEXT: [PlanScheme[], string[]][] = [
  [
    [PlanScheme.Worldwide],
    ['outbound.select_plan.coverage.worldwide_desc'], // prettier-ignore
  ],
  [
    [PlanScheme.Worldwide, PlanScheme.WorldwideExcludingUSAAndCanada],
    ['outbound.select_plan.coverage.worldwide_desc'], // prettier-ignore
  ],
  [
    [PlanScheme.WorldwideExcludingUSAAndCanada],
    ['outbound.select_plan.coverage.worldwide_desc'], // prettier-ignore
  ],
  [
    [PlanScheme.WorldwideExcludingUSAAndCanada, PlanScheme.Regional],
    ['outbound.select_plan.coverage.regional_desc'],
  ],
  [
    [PlanScheme.WorldwideExcludingUSAAndCanada, PlanScheme.FlyEurope],
    ['outbound.select_plan.coverage.fly_europe_desc'],
  ],
]

export const COMBINATION_COVERAGE_LIMIT_TEXT: [PlanScheme[], string[]][] = [
  [
    [PlanScheme.WorldwideExcludingUSAAndCanada, PlanScheme.FlyEurope],
    ['outbound.select_plan.coverage_limit.europe_limit'],
  ],
]

export const COMBINATION_EXTENDED_COVERAGE_TEXT: [PlanScheme[], string[]][] = [
  [
    [PlanScheme.Worldwide],
    ['outbound.select_plan.coverage.worldwide'], // prettier-ignore
  ],
  [
    [PlanScheme.Worldwide, PlanScheme.WorldwideExcludingUSAAndCanada],
    ['outbound.select_plan.coverage.worldwide'], // prettier-ignore
  ],
  [
    [PlanScheme.WorldwideExcludingUSAAndCanada, PlanScheme.Regional],
    ['outbound.select_plan.coverage.worldwide', 'outbound.select_plan.coverage.worldwide_excl'],
  ],
  [
    [PlanScheme.WorldwideExcludingUSAAndCanada, PlanScheme.FlyEurope],
    ['outbound.select_plan.coverage.worldwide', 'outbound.select_plan.coverage.worldwide_excl'],
  ],
]

export const COMBINATION_INCREASED_LIMIT_TEXT: [PlanScheme[], string[]][] = [
  [
    [PlanScheme.WorldwideExcludingUSAAndCanada, PlanScheme.FlyEurope],
    ['outbound.select_plan.coverage_limit.non_europe_limit'],
  ],
]
